import Component from '../component';
import {TweenMax} from "gsap/esm/TweenMax";

export default class Menu extends Component {
	constructor(...args) {
		super(...args);

		this._canClick = true;
		this._maskExist = ( !this.dom.component.classList.contains('no-mask') );

		this._retrieveDOM();

		console.log("CONSTRUCTOR MENU");
	}

	_retrieveDOM() {

		this.dom.btnMenu = document.body.querySelector('.js-toggle');
		this.dom.innerMenu = this.dom.component.querySelector('.inner-menu');
		this.dom.itemMenu = this.dom.component.querySelectorAll('.js-menu-item');
		this.dom.footer = this.dom.component.querySelectorAll('.footer-menu');
		this.dom.mask = this.dom.component.querySelector('.mask-anim');

	}

	bind(){
		super.bind();

		// Ouverture menu
		this.dom.btnMenu.addEventListener('click', this._toggle.bind(this));

		// Ajout bg menu
		if( this._maskExist ) {
			this._toggleBackground();
			window.addEventListener('scroll', this._toggleBackground.bind(this));
		}

		// Ouverture sous menu
		for (let i = 0; i < this.dom.itemMenu.length; i++) {
			let item = this.dom.itemMenu[i];

			item.addEventListener('click', ()=>{
				if ( item.getAttribute( 'data-close' ) === "true" ){
					this._openLink(item);
				}
				else {
					this._closeLink(item);
				}
			});
		}
	}

	_toggle() {
		if (!this._canClick)
			return;
		this._canClick = false;

		var scrollMethod = (window.pageYOffset || document.documentElement.scrollTop) - (document.documentElement.clientTop || 0);

		if (!this.dom.component.classList.contains('show')){
			TweenMax.to(this.dom.mask, 0.5, {height: 0, ease: Power3.easeInOut,});
			this._open();
		}
		else{
			this._close();
			if ( scrollMethod > this.scrollY && this._maskExist ){
				TweenMax.to(this.dom.mask, 0.5, {height: this.height, ease: Power3.easeInOut, delay: 0.4});
			}
		}
	}

	_openLink(item){
		this.dom.childLink = item.querySelector('.menu-child');

		// Close other links
		var delay = ( this._closeAllSubMenu() == false ) ? 0 : 500;
		setTimeout( () => {
			TweenMax.to(this.dom.childLink,0.5, {
				maxHeight: '300px',
				autoAlpha: 1,
				margin: "12px 0 12px 45px",
				ease: Power3.easeInOut
			});

			item.setAttribute("data-close", "false");
		}, delay ); // Wait for closing of all subitems before opening new one


	}

	_closeLink(item){
		this.dom.childLink = item.querySelector('.menu-child');

		TweenMax.to(this.dom.childLink,0.5, {
			autoAlpha: 0,
			// height: 0,
			maxHeight: 0,
			margin: 0,
			ease: Power3.easeInOut
		});

		item.setAttribute("data-close", "true");
	}

	_toggleBackground(){
		//Calcul position fenetre
		var scrollMethod = (window.pageYOffset || document.documentElement.scrollTop) - (document.documentElement.clientTop || 0);

		//Anim display background
		if (scrollMethod > this.scrollY){
			TweenMax.to(this.dom.mask, 0.5, {height: this.height, ease: Power3.easeInOut, onComplete: ()=>{this.dom.component.classList.add('scroll');}})
		}
		else if (scrollMethod < this.scrollY){
			TweenMax.to(this.dom.mask, 0.5, {height: 0, ease: Power3.easeInOut})
			this.dom.component.classList.remove('scroll');
		}
	}


	_closeAllSubMenu() {
		var closing = false;
		this.dom.childLinks = this.dom.component.querySelectorAll('.menu-child');
		for( var i = 0, j = this.dom.childLinks.length; i < j; i++ )
		{
			TweenMax.to(this.dom.childLinks[i], 0.5, {
				autoAlpha: 0,
				// height: 0,
				maxHeight: 0,
				margin: 0,
				ease: Power3.easeInOut
			});

			// Return closing to know if we have to delay next opening
			if( this.dom.itemMenu[i].getAttribute( 'data-close' ) == "false" )
				closing = true;
			this.dom.itemMenu[i].setAttribute("data-close", "true");
		}

		return closing;
	}
	/*
	init() {
	}
	bind() {
	}
	unbind() {
	}
	resize(width, height) {
	}
	*/
}



// WEBPACK FOOTER //
// ./src/js/components/menu/menu.js